export const iconFontAwesomeUsersPeoplePersonDressBurst = (
	<i className="fa-solid fa-person-dress-burst"></i>
);
